import { SvgIconProps } from '@mui/material';

const WheelClicker = ({ width = '83', height = '96', className }: SvgIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 83 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M24.0539 28.4501C29.6408 26.2347 35.6094 25.1482 41.6167 25.2531C47.6239 25.3579 53.5513 26.6521 59.058 29.0613"
      stroke="#263D4B"
      strokeWidth="1.9779"
      strokeMiterlimit="10"
    />
    <g filter="url(#filter0_d_1160_28528)">
      <path
        d="M21.9134 22.8663C28.2241 20.3614 34.9658 19.129 41.7523 19.2397C48.5389 19.3504 55.237 20.802 61.4633 23.5113L40.8364 71.1159L24.0545 28.4498L21.9134 22.8663Z"
        fill="#FEF9EC"
      />
      <path
        d="M21.9134 22.8663C28.2241 20.3614 34.9658 19.129 41.7523 19.2397C48.5389 19.3504 55.237 20.802 61.4633 23.5113L40.8364 71.1159L24.0545 28.4498L21.9134 22.8663Z"
        stroke="#263D4B"
        strokeWidth="1.9779"
        strokeMiterlimit="10"
      />
    </g>
    <path
      d="M26.96 35.8381C28.1423 35.6946 29.3414 35.8675 30.4355 36.3392C32.048 37.0415 33.3162 38.3571 33.9612 39.9968C34.6061 41.6365 34.5749 43.4658 33.8744 45.0824C33.3778 46.1736 32.6005 47.1127 31.6223 47.8034"
      fill="#D77348"
    />
    <path
      d="M26.96 35.8381C28.1423 35.6946 29.3414 35.8675 30.4355 36.3392C32.048 37.0415 33.3162 38.3571 33.9612 39.9968C34.6061 41.6365 34.5749 43.4658 33.8744 45.0824C33.3778 46.1736 32.6005 47.1127 31.6223 47.8034"
      stroke="#263D4B"
      strokeWidth="1.9779"
      strokeMiterlimit="10"
    />
    <path
      d="M44.3047 41.5875C47.6626 43.0499 51.5672 41.5065 53.0258 38.1401C54.4844 34.7738 52.9448 30.8593 49.5868 29.3969C46.2289 27.9345 42.3244 29.478 40.8657 32.8443C39.4071 36.2107 40.9468 40.1251 44.3047 41.5875Z"
      fill="#D77348"
      stroke="#263D4B"
      strokeWidth="1.9779"
      strokeMiterlimit="10"
    />
    <path
      d="M45.0688 61.3473C43.9516 61.3833 42.8435 61.1355 41.8475 60.6269C40.8515 60.1183 39.9999 59.3655 39.3719 58.4385C38.744 57.5115 38.36 56.4403 38.2558 55.3247C38.1516 54.209 38.3304 53.085 38.7758 52.0572C39.2211 51.0294 39.9184 50.1313 40.8029 49.4462C41.6874 48.7611 42.7304 48.3114 43.8348 48.1388C44.9392 47.9662 46.0692 48.0764 47.1197 48.4592C48.1703 48.8419 49.1072 49.4847 49.8435 50.3279"
      fill="#D77348"
    />
    <path
      d="M45.0688 61.3473C43.9516 61.3833 42.8435 61.1355 41.8475 60.6269C40.8515 60.1183 39.9999 59.3655 39.3719 58.4385C38.744 57.5115 38.36 56.4403 38.2558 55.3247C38.1516 54.209 38.3304 53.085 38.7758 52.0572C39.2211 51.0294 39.9184 50.1313 40.8029 49.4462C41.6874 48.7611 42.7304 48.3114 43.8348 48.1388C44.9392 47.9662 46.0692 48.0764 47.1197 48.4592C48.1703 48.8419 49.1072 49.4847 49.8435 50.3279"
      stroke="#263D4B"
      strokeWidth="1.9779"
      strokeMiterlimit="10"
    />
    <path
      d="M58.8369 28.7566C45.4741 23.6285 37.9279 23.2618 24.3438 27.9832L22.145 22.5689C37.4349 17.6942 46.036 17.7662 61.4207 23.4495L58.8369 28.7566Z"
      fill="#FEF9EC"
      stroke="#263D4B"
      strokeWidth="1.5"
    />
    <defs>
      <filter
        id="filter0_d_1160_28528"
        x="0.640533"
        y="0.243164"
        width="82.1228"
        height="95.4609"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0452083 0 0 0 0 0.12589 0 0 0 0 0.175 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1160_28528" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1160_28528"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default WheelClicker;
